// i18n çoklu dil altyapısı.
//
// Strateji:
//   1) Dil seçimi önceliği: localStorage('hent_lang') → user.language → tarayıcı → 'tr'
//   2) Kullanıcı LangSwitcher ile dil değiştirince localStorage + (girişliyse) backend /auth/profile
//   3) Tüm yeni UI metinleri t('namespace.key') üzerinden alınır
//   4) Tarih/sayı/para Intl API ile dil-aware
//
// Dosya organizasyonu:
//   - tr.json: Türkçe (kaynak dil, tam)
//   - en.json: English (kademeli — pilot modüller önce)
//   - ar.json (gelecek): Arapça (RTL desteği gerekecek)

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import tr from './tr.json';
import en from './en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: tr },
      en: { translation: en },
    },
    fallbackLng: 'tr',
    supportedLngs: ['tr', 'en'],
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'hent_lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false }, // React zaten escape eder
    react: { useSuspense: false },
  });

// HTML lang attribute'u senkronize et (CSS / accessibility için)
i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
});
if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language || 'tr';
}

export default i18n;

// ── Yardımcılar (locale-aware format) ───────────────────────────────
export function localeOf() {
  const lng = i18n.language || 'tr';
  return lng === 'tr' ? 'tr-TR' : (lng === 'en' ? 'en-US' : lng);
}

export function fmtDate(d, opts) {
  if (!d) return '';
  const dt = (d instanceof Date) ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return '';
  return new Intl.DateTimeFormat(localeOf(), opts || { year: 'numeric', month: '2-digit', day: '2-digit' }).format(dt);
}

export function fmtNumber(n, opts) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '';
  return new Intl.NumberFormat(localeOf(), opts || { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
}

export function fmtCurrency(n, currency) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '';
  return new Intl.NumberFormat(localeOf(), {
    style: 'currency', currency: currency || 'TRY', minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(v);
}
